import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from 'utils/messageHandler';
import { TitleGenerator } from 'utils/TitleGenerator';

const propsSlice = createSlice({
  name: 'props',
  initialState: {
    branchOfficeProps: { list: [], length: 0 },
    sharedProps: { list: [], length: 0, neighborhoods: [] },
    form: null,
    types: [],
    neighborhoods: [],
    neighborhoodsObj: {},
    neighborhoodsFlat: [],
    loading: false,
    loadingActions: false,
    copyLoadingById: {}
  },
  reducers: {
    setPropsArray: (state, { payload }) => {
      state.branchOfficeProps.list = payload.response;
      state.branchOfficeProps.length = payload.length;
      state.branchOfficeProps.neighborhoods = payload.neighborhoods;
      state.loading = false;
    },
    setPropsToInitial: state => {
      state.branchOfficeProps = { list: [], length: 0 };
    },
    setSharedProps: (state, { payload }) => {
      state.sharedProps.list = payload.result;
      state.sharedProps.length = payload.allPropertiesLength;
      state.sharedProps.neighborhoods = payload.neighborhoods;
      state.sharedProps.realEstates = payload.realEstates;
      state.loading = false;
    },
    setForm: (state, { payload }) => {
      state.form = payload;
    },
    setTypes: (state, { payload }) => {
      state.types = payload.sort((a, b) =>
        a.propertyType > b.propertyType ? 1 : -1
      );
    },
    setNeighborhoods: (state, { payload }) => {
      state.neighborhoods = payload;
    },
    setNeighborhoodsObj: (state, { payload }) => {
      state.neighborhoodsObj = payload;
    },
    setNeighborhoodsFlat: (state, { payload }) => {
      state.neighborhoodsFlat = payload;
    },
    cleanForm: state => {
      state.form = null;
    },
    request: state => {
      state.loading = true;
    },
    requestEnd: state => {
      state.loading = false;
    },
    requestActions: state => {
      state.loadingActions = true;
    },
    requestActionsEnd: state => {
      state.loadingActions = false;
    },
    setCopyLoadingById: (state, { payload }) => {
      const { id, loading } = payload;
      state.copyLoadingById[id] = loading;
    }
  }
});

export const {
  setPropsArray,
  setPropsToInitial,
  setForm,
  setTypes,
  cleanProps,
  setSharedProps,
  setNeighborhoods,
  setNeighborhoodsObj,
  setNeighborhoodsFlat,
  cleanForm,
  request,
  requestEnd,
  requestActions,
  requestActionsEnd,
  setCopyLoadingById
} = propsSlice.actions;

export const getPropertiesForms = propertyType => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/properties/forms/${propertyType}`
    );

    dispatch(setForm(data));
  } catch (e) {
    console.log(e);
  }
};

export const getPropertiesTypes = () => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/properties/types`
    );

    dispatch(setTypes(data));
  } catch (e) {
    console.log(e);
  }
};

export const getPropertiesByFilters =
  (filtersAndSort, page, propsLimit, searchProp, searchAddress) =>
  async dispatch => {
    //Retorna todas las props en un objeto por oficina

    // if (filtersAndSort.branchOffices[0]) {
    dispatch(request());
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER}/properties/branch-office?offset=${
        page - 1
      }&limit=${propsLimit}&field=${searchProp}&address=${searchAddress}`,
      filtersAndSort
    );

    const data = {
      response: response.data.result,
      length: response.data.allPropertiesLength,
      neighborhoods: response.data.neighborhoods
    };
    dispatch(setPropsArray(data));
  };
// };

export const setPropsArrayToInitial = () => async dispatch => {
  dispatch(setPropsToInitial());
};

export const getSharedProperties =
  (
    filtersAndSort,
    page,
    propsLimit,
    searchProp,
    searchAddress,
    excludedRealEstateId
  ) =>
  async dispatch => {
    try {
      dispatch(request());
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/properties/shared?offset=${
          page - 1
        }&limit=${propsLimit}&field=${searchProp}&address=${searchAddress}`,
        { ...filtersAndSort, excludedRealEstateId }
      );

      dispatch(setSharedProps(data));
    } catch (e) {
      console.log(e);
    }
  };

export const getExcelSharedProperties = props => async () => {
  try {
    const propsDto = props.map(prop => {
      return {
        tipoDePropiedad: prop.propertyType,
        cantDeAmb: prop.ambiences,
        barrio: prop.neighborhood,
        precio: prop.price,
        linkDeLaPropiedad: `${process.env.REACT_APP_CLIENT_DETAIL}${
          prop.id
        }/${TitleGenerator(prop.title)}`,
        datosInmobiliaria: prop.real_estate.name,
        porcentajeQueComparte: prop.share.percent
      };
    });

    const response = await axios.post(
      `${process.env.REACT_APP_SERVER}/properties/save-property-details`,
      propsDto,
      {
        responseType: 'arraybuffer'
      }
    );
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const getPropById = id => async () => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/properties/${id}?admin=true`
    );

    return data;
  } catch (e) {
    console.log(e);
  }
};

export const createProp = info => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/properties`,
      info
    );

    return data.property._id;
  } catch (e) {
    console.log(e);
  }
};

export const changeStatus = (id, status) => async dispatch => {
  try {
    dispatch(requestActions());
    dispatch(request());
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/upload-characteristics/${id}`,
      {
        status: status
      }
    );

    messageHandler('success', response?.data?.message);
    return response.status;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    return e.response.status;
  } finally {
    dispatch(requestEnd());
    dispatch(requestActionsEnd());
  }
};

export const changeMultipleStatus = (id, status) => async dispatch => {
  try {
    dispatch(requestActions());
    dispatch(request());
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/upload-characteristics/${id}`,
      {
        status: status
      }
    );
    return response;
  } catch (e) {
    return e.response;
  } finally {
    dispatch(requestEnd());
    dispatch(requestActionsEnd());
  }
};

export const changeMultipleShare = (id, share) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/basic-data/${id}`,
      {
        share
      }
    );
    return response.status;
  } catch (e) {
    return e.response.status;
  }
};

export const setPropActive = id => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/publish/${id}`,
      {
        status: 'published'
      }
    );

    messageHandler('success', response?.data?.message);
    return response.status;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    return e.response.status;
  }
};

export const deleteProp = id => async dispatch => {
  try {
    dispatch(request());
    dispatch(requestActions());
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER}/properties/logical/${id}`
    );
    messageHandler('success', 'Propiedad eliminada correctamente');
    return response.status;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e.response.status;
  } finally {
    dispatch(requestEnd());
    dispatch(requestActionsEnd());
  }
};

export const deleteMultipleProp = id => async dispatch => {
  try {
    dispatch(request());
    dispatch(requestActions());
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER}/properties/logical/${id}`
    );
    return response.status;
  } catch (e) {
    return e.response.status;
  } finally {
    dispatch(requestEnd());
    dispatch(requestActionsEnd());
  }
};

export const physicDelete = id => async () => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER}/properties/phisical/${id}`
    );

    messageHandler('success', response?.data?.message);
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const uploadCharacteristics = (prop, id) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/upload-characteristics/${id}`,
      prop
    );

    return response;
  } catch (e) {
    return e.response;
  }
};

export const setImagesOrder = (id, filesOrder, accessor) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/set-images-order/${id}`,
      {
        filesOrder,
        accessor
      }
    );

    return response.status;
  } catch (e) {
    messageHandler('error', 'No se pudo cambiar el orden de las imágenes');
    return e.response.status;
  }
};

export const uploadImage = (id, formData) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/upload-multimedia/${id}`,
      formData
    );
    return response;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    return e.response;
  }
};

export const editImage = (id, formData) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/edit-image/${id}`,
      formData
    );

    return response;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    return e.response;
  }
};

export const imageDelete = (propertyId, fileName, accessor) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/delete-image/${propertyId}`,
      {
        filename: fileName,
        accessor
      }
    );

    return response;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    return e.response;
  }
};

export const editBasicData = (prop, id) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/basic-data/${id}`,
      prop
    );

    return response;
  } catch (e) {
    return e.response;
  }
};

export const changeShare = (id, percent, active, handleClose) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/properties/change-share/${id}`,
      {
        percent: percent,
        active: active
      }
    );

    handleClose && handleClose();

    return response;
  } catch (e) {
    return e.response;
  }
};

export const getNeighborhoods = () => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/utils/barrios`
    );

    dispatch(setNeighborhoods(data));
  } catch (e) {
    console.log(e);
  }
};

export const getNeighborhoodsObj = () => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/utils/barrios-obj`
    );

    dispatch(setNeighborhoodsObj(data));
  } catch (e) {
    console.log(e);
  }
};

export const getNeighborhoodsFlat = () => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/utils/barrios-flat`
    );

    dispatch(setNeighborhoodsFlat(data));
  } catch (e) {
    console.log(e);
  }
};

export const copyProperty = id => async dispatch => {
  try {
    dispatch(setCopyLoadingById({ id, loading: true }));
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/properties/copy/${id}`
    );

    messageHandler('success', data.message);
    return data.newProperty._id;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
    return e.response.status;
  } finally {
    dispatch(setCopyLoadingById({ id, loading: false }));
  }
};

export default propsSlice.reducer;
